export default {
    email: {
        placeholder: "Inserisci l'email del destinatario",
        label: "Email destinatario",
        validate: "Inserisci un'email valida"
    },
    subject: {
        placeholder: "Inserisci l'oggetto dell'email",
        label: "Oggetto",
        validate: "L'oggetto è obbligatorio"
    },
    message: {
        placeholder: "Scrivi il tuo messaggio",
        label: "Messaggio",
        validate: "Il messaggio è obbligatorio"
    }
}
  